import React, { useState } from "react";
import { Modal, Button, message } from "antd";
import { FaClock } from "react-icons/fa";
import styles from "../../../styles/Components/alert-system/alert-config/SignalTimeFrameModal.module.css";
import { useSelector } from "react-redux";
import useChangeAlertSystemSettings from "../../../hooks/api/alert-system/useChangeAlertSystemSettings";

const SignalTimeFrameModal = ({ visible, onClose, onSelect }) => {
  const { activeAlertLoading, alertStatus } = useSelector(
    (state) => state.alertSystem,
  );

  const changeSettings = useChangeAlertSystemSettings();

  const [selectedTimeFrame, setSelectedTimeFrame] = useState(
    alertStatus?.alert_frequency || "5m",
  );
  const timeFrames = ["5m", "15m", "30m", "1H", "2H", "4H", "6H", "12H", "1D"];

  const handleTimeFrameClick = (timeFrame) => {
    setSelectedTimeFrame(timeFrame);
    console.log(timeFrame);
  };

  const closeModal = (e) => {
    if (activeAlertLoading)
      return message.info("Please wait a moment while the process completes.");
    e.stopPropagation();
    onClose();
  };

  const submitHandler = (e) => {
    e.stopPropagation();
    changeSettings({ alertFrequency: selectedTimeFrame }).then(onClose);
  };

  return (
    <Modal
      open={visible}
      onCancel={closeModal}
      title={
        <div className={styles.modalTitleContainer}>
          <FaClock className={styles.modalIcon} />
          <span>Select Signal Time Frame</span>
        </div>
      }
      footer={null}
    >
      <div className={styles.timeFrameContainer}>
        {timeFrames.map((timeFrame) => (
          <span
            key={timeFrame}
            className={`${styles.timeFrameButton} ${
              selectedTimeFrame === timeFrame ? styles.selected : ""
            }`}
            onClick={() => handleTimeFrameClick(timeFrame)}
          >
            {timeFrame}
          </span>
        ))}
      </div>
      <div className={styles.footer}>
        <Button
          className={styles.submitBtn}
          loading={activeAlertLoading}
          disabled={!selectedTimeFrame}
          onClick={submitHandler}
        >
          Submit
        </Button>
      </div>
    </Modal>
  );
};

export default SignalTimeFrameModal;
